"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var Icon_1 = require("../../Icon");
var ButtonUtils_1 = require("../Button/ButtonUtils");
exports.IconButton = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? '' : _b, _c = _a.toggled, toggled = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.buttonSize, buttonSize = _e === void 0 ? 'large' : _e, _f = _a.includeDropdownButton, includeDropdownButton = _f === void 0 ? false : _f, className = _a.className, _g = _a.customButtonSize, customButtonSize = _g === void 0 ? '' : _g, _h = _a.customIconSize, customIconSize = _h === void 0 ? '' : _h, _j = _a.buttonStyleType, buttonStyleType = _j === void 0 ? 'PRIMARY' : _j, rest = tslib_1.__rest(_a, ["icon", "toggled", "disabled", "buttonSize", "includeDropdownButton", "className", "customButtonSize", "customIconSize", "buttonStyleType"]);
    var _k = ButtonUtils_1.getThemeForIconButtonType(buttonStyleType, toggled), background = _k.background, color = _k.color, hoverBackground = _k.hoverBackground, hoverColor = _k.hoverColor, focusBackground = _k.focusBackground, focusColor = _k.focusColor, focusVisibleBackground = _k.focusVisibleBackground, focusVisibleColor = _k.focusVisibleColor;
    var getEmFromButtonSize = function (size) {
        switch (size) {
            case 'xsmall':
                return 0.78;
            case 'small':
                return 1.0;
            case 'medium':
                return 1.33;
            case 'large':
                return 1.8;
            default:
                return 1.8;
        }
    };
    return (react_1.default.createElement(StyledButton, tslib_1.__assign({}, rest, { background: background, color: color, hoverBackground: hoverBackground, hoverColor: hoverColor, focusBackground: focusBackground, focusColor: focusColor, focusVisibleBackground: focusVisibleBackground, focusVisibleColor: focusVisibleColor, disableRipple: true, includeDropdownButton: includeDropdownButton, buttonSize: getEmFromButtonSize(buttonSize), fontSize: buttonSize === 'xsmall' ? '1.4rem' : '1.8rem', toggled: toggled, disabled: disabled, customIconSize: customIconSize, customButtonSize: customButtonSize, className: clsx_1.default(className, {
            isDisabled: disabled,
            custom: customIconSize || customButtonSize,
        }), buttonStyleType: buttonStyleType }),
        react_1.default.createElement(Icon_1.Icon, { name: icon }),
        includeDropdownButton && (react_1.default.createElement("i", { className: "icon--menu_" + (toggled ? 'up' : 'down') + " button_dropdown" }))));
};
var StyledButton = styled_components_1.default(function (_a) {
    var toggled = _a.toggled, customIconSize = _a.customIconSize, customButtonSize = _a.customButtonSize, buttonStyleType = _a.buttonStyleType, background = _a.background, buttonSize = _a.buttonSize, includeDropdownButton = _a.includeDropdownButton, fontSize = _a.fontSize, color = _a.color, hoverBackground = _a.hoverBackground, hoverColor = _a.hoverColor, focusBackground = _a.focusBackground, focusColor = _a.focusColor, focusVisibleBackground = _a.focusVisibleBackground, focusVisibleColor = _a.focusVisibleColor, rest = tslib_1.__rest(_a, ["toggled", "customIconSize", "customButtonSize", "buttonStyleType", "background", "buttonSize", "includeDropdownButton", "fontSize", "color", "hoverBackground", "hoverColor", "focusBackground", "focusColor", "focusVisibleBackground", "focusVisibleColor"]);
    return react_1.default.createElement(core_1.IconButton, tslib_1.__assign({}, rest));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    background-color: ", ";\n    color: ", ";\n    border: none;\n    border-radius: 0%;\n    font-size: ", ";\n    height: ", ";\n    width: ", ";\n    padding: 0;\n\n    && i {\n      font-size: inherit;\n    }\n\n    && i.button_dropdown {\n      font-size: 1.2rem;\n      margin-top: 0.2rem;\n      margin-left: 0.1rem;\n    }\n\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus-visible {\n      background-color: ", ";\n      color: ", ";\n      outline: ", ";\n      outline-offset: 1px;\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &.isDisabled {\n      color: ", ";\n    }\n    &.custom {\n      font-size: ", ";\n    }\n    &.custom i {\n      font-size: ", ";\n    }\n  }\n"], ["\n  && {\n    background-color: ", ";\n    color: ", ";\n    border: none;\n    border-radius: 0%;\n    font-size: ", ";\n    height: ", ";\n    width: ",
    ";\n    padding: 0;\n\n    && i {\n      font-size: inherit;\n    }\n\n    && i.button_dropdown {\n      font-size: 1.2rem;\n      margin-top: 0.2rem;\n      margin-left: 0.1rem;\n    }\n\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &:focus-visible {\n      background-color: ",
    ";\n      color: ", ";\n      outline: ", ";\n      outline-offset: 1px;\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &.isDisabled {\n      color: ", ";\n    }\n    &.custom {\n      font-size: ", ";\n    }\n    &.custom i {\n      font-size: ", ";\n    }\n  }\n"])), function (_a) {
    var background = _a.background;
    return background;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
}, function (_a) {
    var buttonSize = _a.buttonSize;
    return buttonSize + "em";
}, function (_a) {
    var buttonSize = _a.buttonSize, includeDropdownButton = _a.includeDropdownButton;
    return buttonSize + (includeDropdownButton ? 0.4 : 0) + "em";
}, function (_a) {
    var hoverBackground = _a.hoverBackground;
    return hoverBackground;
}, function (_a) {
    var hoverColor = _a.hoverColor;
    return hoverColor;
}, function (_a) {
    var focusBackground = _a.focusBackground;
    return focusBackground;
}, function (_a) {
    var focusColor = _a.focusColor;
    return focusColor;
}, function (_a) {
    var focusVisibleBackground = _a.focusVisibleBackground;
    return focusVisibleBackground;
}, function (_a) {
    var focusVisibleColor = _a.focusVisibleColor;
    return focusVisibleColor;
}, function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.green[400];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[300];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[300];
}, function (_a) {
    var customButtonSize = _a.customButtonSize;
    return customButtonSize + " !important";
}, function (_a) {
    var customIconSize = _a.customIconSize;
    return customIconSize + " !important";
});
var templateObject_1;
